<section class="mu_chat_country" role="dialog" [attr.aria-label]="'shared.chatCountryTitle' | translate">
  <header class="mu_chat_country__header">
    <p class="mu_chat_country__title">{{ 'shared.chatCountryTitle' | translate }}</p>
    <button type="button" class="mu_chat_country__close" [attr.aria-label]="'shared.chatCountryClose' | translate" (click)="dismissed.emit()">
      &times;
    </button>
  </header>
  <button
    *ngFor="let country of countries"
    type="button"
    class="mu_chat_country__option"
    (click)="selected.emit($any(country.geoName))"
  >
    <img class="mu_chat_country__flag" [src]="country.ico" alt="" />
    {{ 'common.location.country.' + country.geoName | translate }}
  </button>
</section>
